/* eslint-disable no-unused-vars, max-len */
const { feWp } = window;
const { addAction } = feWp.hooks;

const updateProgressBar = ( swiper ) => {
  const progressBarFill = swiper.el.querySelector( '.swiper-pagination-progressbar-fill' );
  const activeSlide = swiper.realIndex + 1;
  const progress = ( ( activeSlide / ( swiper.originalSlideCount ) ) ) * 100;
  if ( progressBarFill ) {
    progressBarFill.style.width = progress + '%';
  }
};

addAction(
  'b3rg_slider_init',
  'b3rg/slider',
  ( settings, el, swiper ) => {
    const isInfinite = settings.loop;
    const isProgressbar = settings.pagination?.type;
    if ( isInfinite ) {
      swiper.params.supports4k = true;
      swiper.params.longSwipesRatio = 0;
      swiper.params.threshold = 0;
      swiper.params.touchRatio = 0.1;
      swiper.params.autoplay = {
        delay: settings?.autoplay?.delay || 3000, // Set the delay time for autoplay in milliseconds
      };
      if ( isProgressbar ) {
        swiper.params.pagination = {
          el: '.swiper-pagination',
          type: 'custom',
          renderCustom: function ( swiper, current, total ) {
            return '<div class="swiper-pagination-wrpr"><span class="swiper-pagination-progressbar-fill"></span></div><div class="swiper-fraction-custom">' +
              current +
              '/' + ( swiper.originalSlideCount ) + '</div>';
          },
          renderFraction: function () {
            return '';
          }
        };
        el.querySelector( '.swiper-pagination' ).classList.add( 'swiper-pagination-custom' );
        swiper.on( 'slideChange', function () {
          updateProgressBar( this );
        } );
        swiper.on( 'init', function () {
          // Update the progress bar on initialization
          updateProgressBar( this );
        } );
      }
      swiper.update();
    }
  },
  10,
  1,
);